module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-MediumItalic.woff2?fe68865af8822ac42dfbf7589d04b867";